import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ListTaxFilterSpec, Pageable, WrapperPageableResponse } from './service-common';

export interface TaxDTO {
  id: number;
  taxKey: string;
  displayName: string;
  description?: string;
  taxType?: 'VAT' | 'SALES_TAX' | 'EXCISE' | 'WITHHOLDING' | 'INCOME_TAX' | 'OTHER';
  rate?: number;
  validFrom?: string;
  validTo?: string;
  state?: 'ACTIVE' | 'INACTIVE';
}

export type WrapperPageableResponseTaxListDTO = WrapperPageableResponse<TaxDTO>;

@Injectable({
  providedIn: 'root'
})
export class TaxService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  listTaxes(
    spec: ListTaxFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponseTaxListDTO> {
    let params = new HttpParams();

    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });

    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));

    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => {
        params = params.append('sort', sort);
      });
    }

    return this.http.get<WrapperPageableResponseTaxListDTO>(`${this.apiUrl}/taxes/list`, { params });
  }
}
